import { useState } from "react";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import './Photography.css';
import Header from "./Header";


export const Photography = () => {

  const images = [
    { original: "/27703773827_e60b135eb7_o.jpg", thumbnail: "/27703773827_e60b135eb7_o_tmb.jpg", width: 1600, height: 1067 },
    { original: "/26916854849_f762960f9e_o.jpg", thumbnail: "/26916854849_f762960f9e_o_tmb.jpg", width: 1600, height: 1067 },
    { original: "/24842944218_16a3b288cf_o.jpg", thumbnail: "/24842944218_16a3b288cf_o_tmb.jpg", width: 1600, height: 533 },
    { original: "/53025172309_ed62a5a847_o.jpg", thumbnail: "/53025172309_ed62a5a847_o_tmb.jpg", width: 1600, height: 1067 },
    { original: "/52426383285_246df7496d_o.jpg", thumbnail: "/52426383285_246df7496d_o_tmb.jpg", width: 1600, height: 1067 },
    { original: "/52432517053_90f268d1ac_o.jpg", thumbnail: "/52432517053_90f268d1ac_o_tmb.jpg", width: 1067, height: 1600 },
    { original: "/47948179092_976469aeff_o.jpg", thumbnail: "/47948179092_976469aeff_o_tmb.jpg", width: 1600, height: 1067 },
    { original: "/40412792353_e6b070cee6_o.jpg", thumbnail: "/40412792353_e6b070cee6_o_tmb.jpg", width: 1600, height: 1067 },
    { original: "/53263007207_9f145ab1e7_o.jpg", thumbnail: "/53263007207_9f145ab1e7_o_tmb.jpg", width: 1067, height: 1600 },
    { original: "/41452526694_45e81a7d4d_o.jpg", thumbnail: "/41452526694_45e81a7d4d_o_tmb.jpg", width: 1067, height: 1600 },
    { original: "/31805598627_a5a38d0cd4_o.jpg", thumbnail: "/31805598627_a5a38d0cd4_o_tmb.jpg", width: 1067, height: 1600 },
    { original: "/32409235078_7f57eefc96_o.jpg", thumbnail: "/32409235078_7f57eefc96_o_tmb.jpg", width: 1600, height: 1067 },
    { original: "/32409319858_56e4a93409_o.jpg", thumbnail: "/32409319858_56e4a93409_o_tmb.jpg", width: 1067, height: 1600 },
    { original: "/39123364801_512de8313f_o.jpg", thumbnail: "/39123364801_512de8313f_o_tmb.jpg", width: 1067, height: 1600 },
    { original: "/39781821353_bdaaa181c4_o.jpg", thumbnail: "/39781821353_bdaaa181c4_o_tmb.jpg", width: 1600, height: 1067 },
    { original: "/43831822800_34db9f4cf1_o.jpg", thumbnail: "/43831822800_34db9f4cf1_o_tmb.jpg", width: 1600, height: 533 },
    { original: "/44120651372_3b47f92a7f_o.jpg", thumbnail: "/44120651372_3b47f92a7f_o_tmb.jpg", width: 1600, height: 1067 },
    { original: "/44411965532_929053818d_o.jpg", thumbnail: "/44411965532_929053818d_o_tmb.jpg", width: 1600, height: 1067 },
    { original: "/46793610402_41567466a0_o.jpg", thumbnail: "/46793610402_41567466a0_o_tmb.jpg", width: 1600, height: 1067 },
    { original: "/48210036262_49ec6ef8fd_o.jpg", thumbnail: "/48210036262_49ec6ef8fd_o_tmb.jpg", width: 1067, height: 1600 },
    { original: "/48285766597_61480c827a_o.jpg", thumbnail: "/48285766597_61480c827a_o_tmb.jpg", width: 1600, height: 1067 },
    { original: "/49269651032_2f932cfbfc_o.jpg", thumbnail: "/49269651032_2f932cfbfc_o_tmb.jpg", width: 1600, height: 1067 },
    { original: "/49820075586_b727ddf5ae_o.jpg", thumbnail: "/49820075586_b727ddf5ae_o_tmb.jpg", width: 1600, height: 1067 },
    { original: "/49935926402_3b95b3ae62_o.jpg", thumbnail: "/49935926402_3b95b3ae62_o_tmb.jpg", width: 1600, height: 1067 },
    { original: "/50903015688_c0de3e6c6c_o.jpg", thumbnail: "/50903015688_c0de3e6c6c_o_tmb.jpg", width: 1600, height: 1067 },
    { original: "/50909614233_791113a41d_o.jpg", thumbnail: "/50909614233_791113a41d_o_tmb.jpg", width: 1600, height: 1067 },
    { original: "/51501359921_f962e96a25_o.jpg", thumbnail: "/51501359921_f962e96a25_o_tmb.jpg", width: 1600, height: 1067 },
    { original: "/52127279006_51331a3bb7_o.jpg", thumbnail: "/52127279006_51331a3bb7_o_tmb.jpg", width: 1600, height: 1067 },
    { original: "/52425426932_6851b1999b_o.jpg", thumbnail: "/52425426932_6851b1999b_o_tmb.jpg", width: 1600, height: 1067 },
    { original: "/53083620937_6bc61e6f81_o.jpg", thumbnail: "/53083620937_6bc61e6f81_o_tmb.jpg", width: 1600, height: 1067 },
    { original: "/53103685240_957cc82ab0_o.jpg", thumbnail: "/53103685240_957cc82ab0_o_tmb.jpg", width: 1600, height: 1067 },
  ];


  return (
    <div className="page-content">
      <Header /> 
      <ImageGallery items={images} 
        showThumbnails={true}
        showPlayButton={false} />
    </div>
  );
};

export default Photography;
